/**
 * Capitalizes the first letter of a string and converts the rest to lowercase
 */
export const capitalizeFirst = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
